import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetPqrMailHistoryWithArea } from '../../../../../../services/pqr.service'; // ajusta según ruta
import { TableTooltip } from '../../../../../components/general/table';
import DateTimeFormat from '../../../../../components/dateTimeFormat';
import { PqrMailHistoryProps } from './props';
import { PqrMailHistory } from '../../../../../../shared/types/modules/pqr';

export const usePqrMailHistoryWithArea = ({ pqrId }: PqrMailHistoryProps) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<PqrMailHistory[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<PqrMailHistory>[] = [
        {
            field: 'subject',
            headerName: 'Asunto',
            minWidth: 180,
            flex: 1,
            renderCell: (params) => (
                <TableTooltip value={params.row.subject || ''} />
            ),
        },
        {
            field: 'status',
            headerName: 'Estado',
            width: 150,
            renderCell: (params) => {
                const val = params.value;

                if (val == null) return '';

                const code = Number(val);
                if (!isNaN(code) && code >= 200 && code < 300) {
                    return 'ENVIADO';
                }

                return '';
            },
        },
        {
            field: 'sent_at',
            headerName: 'Fecha de envío',
            minWidth: 150,
            flex: 0.5,
            renderCell: (params) => (
                <DateTimeFormat dateAt={params.row.sent_at} />
            ),
        },
        {
            field: 'to',
            headerName: 'Para',
            minWidth: 180,
            flex: 0.8,
            renderCell: (params) => {
                const to = Array.isArray(params.row.to)
                    ? params.row.to.join(', ')
                    : params.row.to || '';
                return <TableTooltip value={to} />;
            },
        },
        {
            field: 'cc',
            headerName: 'Con copia',
            minWidth: 180,
            flex: 0.8,
            renderCell: (params) => (
                <TableTooltip value={params.row.cc || ''} />
            ),
        },
        {
            field: 'bcc',
            headerName: 'Copia oculta a',
            minWidth: 180,
            flex: 0.8,
            renderCell: (params) => (
                <TableTooltip value={params.row.bcc || ''} />
            ),
        },
        {
            field: 'sent_by',
            headerName: 'Enviado por',
            minWidth: 120,
            flex: 0.4,
            renderCell: (params) => (
                <TableTooltip value={params.row.sent_by || ''} />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha creación',
            minWidth: 150,
            flex: 0.5,
            renderCell: (params) => (
                <DateTimeFormat dateAt={params.row.created_at} />
            ),
        },
    ];

    useEffect(() => {
        setLoading(true);
        asyncGetPqrMailHistoryWithArea(pqrId, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, pqrId]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
